module.exports = __webpack_public_path__ + "img/html5.59e3aa8c.png";